import * as React from 'react'
import * as formik from 'formik'
import styled from 'styled-components'

import * as plume from '@ulule/owl-kit-components/next'
import * as model from '@owl-nest/models'
import { t } from '@owl-nest/localize'

import { useStep, getStepIndex, getStepProgress, Step } from '../useStep'
import { Progress } from '../components/Progress'
import { Coaching } from '../components/Coaching'
import { Actions } from '../components/Actions'
import { Tip } from '../components/Tip'

import { SolidContent } from './styles'

type SlugProps = {
  project: model.project.ProjectForOwner
}

export function Slug({ project }: SlugProps): React.ReactElement {
  const { setStepValue } = useStep(project)

  return (
    <>
      <Progress progress={getStepProgress(Step.SLUG)} step={getStepIndex(Step.SLUG)} name={t('Your project’s title')} />
      <Coaching project={project}>
        {t(
          'Give your project a title. A good title should be neither too long nor too short, try to be punchy and use keywords.',
        )}
      </Coaching>

      <formik.Formik
        initialValues={{
          slug: '',
        }}
        onSubmit={(values) => {
          const slug = values.slug
          setStepValue(slug ? { name: { [project.lang]: slug }, slugify: true } : {})
        }}
      >
        {(formikBag) => {
          return (
            <Form onSubmit={formikBag.handleSubmit}>
              <SolidContent>
                <formik.Field name="slug">
                  {({ field }: formik.FieldProps<string>) => {
                    return <plume.TextField label={t('Title of your project')} maxLength={60} {...field} />
                  }}
                </formik.Field>
              </SolidContent>

              <Tip>{t('Nothing final, you can edit this information later.')}</Tip>
              <Actions>
                <plume.LinkAsButton kind="secondary" type="button" onClick={() => setStepValue()}>
                  {t('Skip')}
                </plume.LinkAsButton>
                <plume.Button kind="primary">{t('Next')}</plume.Button>
              </Actions>
            </Form>
          )
        }}
      </formik.Formik>
    </>
  )
}

const Form = styled.form`
  height: calc(100% - (132px + 4 * 22px));

  ${plume.TextField} {
    max-width: 600px;
    margin-left: auto;
    margin-right: auto;
  }
`
